var WarmupQuestions = require("lib/academic/WarmupQuestions");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

class FictionPointOfViewQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	isPictureBook() {
		if (this.props.answers[TopicQuestion.STEM]) {
			return this.props.answers[TopicQuestion.STEM][TopicQuestion.TEXT_TYPE] == "picture book";			
		}
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionPointOfViewQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [TYPE_STAGE];
		}

		if (!answers[POV_TYPE]) {
			return [TYPE_STAGE];
		}

		if (this.props.level == "1") {
			if (!answers[AUTHOR] || (this.isPictureBook() && !answers[ILLUSTRATOR])) {
				return [NARRATOR_STAGE];
			} else {
				return [NARRATOR_STAGE, true];
			}
		}

		var povType = answers[POV_TYPE];

		if (povType.includes("2nd") || (this.props.level == "2" && povType.includes("3rd"))) {
			return [TYPE_STAGE, true];
		}

		if (povType.includes("1st")) {
			if (!answers[NARRATOR]) {
				return [NARRATOR_STAGE];
			} else {
				return [NARRATOR_STAGE, true];
			}
		}

		if (!answers[THIRD_PERSON_TYPE]) {
			return [THIRD_PERSON_TYPE_STAGE];
		} else if (!answers[THIRD_PERSON_TYPE].includes("limited")) {
			return [THIRD_PERSON_TYPE_STAGE, true];
		}

		if (!answers[THIRD_PERSON_CHAR]) {
			return [THIRD_PERSON_CHAR_STAGE];
		} else {
			return [THIRD_PERSON_CHAR_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var typeDisplay = (
			<div>
				{ this.props.getTextF("label1", TYPE_STAGE) }
				{ this.props.renderDropdownF("choices1", TYPE_STAGE, POV_TYPE, [POV_TYPE]) }.
			</div>
		);

		if (_.indexOf(STAGES, stage) == 1) {
			if (this.props.level == "1") {
				var inputKey = AUTHOR;

				if (this.isPictureBook()) {
					var illustratorDisplay = (
						<div>
							{ this.props.getTextF("label2", NARRATOR_STAGE) }
							{ this.props.renderInputF(ILLUSTRATOR) }
						</div>
					);
				}
			} else {
				var inputKey = NARRATOR;
			}

			var narratorDisplay = (
				<div>
					{ this.props.getTextF("label1", NARRATOR_STAGE) }
					{ this.props.renderInputF(inputKey) }
					{ illustratorDisplay }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			var thirdPersonTypeDisplay =  (
				<div>
					{ this.props.getTextF("label1", THIRD_PERSON_TYPE_STAGE) }
					{ this.props.renderDropdownF("choices1", THIRD_PERSON_TYPE_STAGE, THIRD_PERSON_TYPE, [POV_TYPE]) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var thirdPersonCharDisplay =  (
				<div>
					{ this.props.getTextF("label1", THIRD_PERSON_CHAR_STAGE) }
					{ this.props.renderInputF(THIRD_PERSON_CHAR) }
				</div>
			);
		}

		return (
			<div>
				{ typeDisplay }
				{ narratorDisplay }
				{ thirdPersonTypeDisplay }
				{ thirdPersonCharDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionPointOfViewQuestion.STEM = "fpov";

// stages
var TYPE_STAGE = "povtype";
var NARRATOR_STAGE = "narrator";
var THIRD_PERSON_TYPE_STAGE = "thirdptype";
var THIRD_PERSON_CHAR_STAGE = "thirdpchar";

var STAGES = [
	TYPE_STAGE, NARRATOR_STAGE, THIRD_PERSON_TYPE_STAGE, THIRD_PERSON_CHAR_STAGE
];

// answer keys
var POV_TYPE = "pov_type";
var AUTHOR = "author";
var ILLUSTRATOR = "illustrator";
var NARRATOR = "narrator";
var THIRD_PERSON_TYPE = "third_person_type";
var THIRD_PERSON_CHAR = "third_person_character";

FictionPointOfViewQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionPointOfViewQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionPointOfViewQuestion.js